import { render, staticRenderFns } from "./componentAssigned.vue?vue&type=template&id=20fd6aea&"
import script from "./componentAssigned.vue?vue&type=script&lang=ts&"
export * from "./componentAssigned.vue?vue&type=script&lang=ts&"
import style0 from "./componentAssigned.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports